import * as React from 'react';

const Footer = () => <div>{/*Here is my foooter*/}</div>;

export default Footer;
